import { render } from "./NewFranchiseComponent.vue?vue&type=template&id=2f251369&scoped=true"
import script from "./NewFranchiseComponent.vue?vue&type=script&lang=js"
export * from "./NewFranchiseComponent.vue?vue&type=script&lang=js"

import "./NewFranchiseComponent.vue?vue&type=style&index=0&id=2f251369&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f251369"]])

export default __exports__